import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { getRefundMethods } from './helpers'

const RefundMethodSelector = ({ value = [], onChange, provider }) => {
  const { t } = useTranslation()

  return (
    <div>
      <ComboBox
        label={t('Método de reembolso')}
        menuItems={getRefundMethods(provider).map(rf => ({ label: t(rf.label), value: rf.value }))}
        handleChange={e => onChange(e.target.value)}
        multiple
        value={value || []}
        fullWidth
      />
    </div>
  )
}

export default RefundMethodSelector
